import Vue from 'vue';
import Vuex from 'vuex';
import auth from "@/auth/authService";
import config from '../../config/config.json';

Vue.use(Vuex);

const {Cluster, Namespace, NodePool, Empty} = require('../pb/dashboard_pb.js');
const {AvalancheClient} = require('../pb/dashboard_grpc_web_pb.js');

const grpc = {};
grpc.web = require('grpc-web');

const BASE_URI = config.url;
var avClient = new AvalancheClient(BASE_URI + '/_dashboard', null, null);

const store = new Vuex.Store({
  data () {
    return {
      appsStreams: [],
      nodePoolStream: {}
    }
  },
  state: {
    clusters: {},
    namespaces: {},
    nodepools: {},
    apps: {},
    error: {
      value: false,
      stream: false,
      code: null,
      message: ''
    }
  },
  mutations: {
    resetClusters(state, data) {
    state.clusters = data;
    },
    updateClusters(state, ns) {
      Vue.set(state.clusters, ns.name, ns);
    },
    resetNamespaces(state, data) {
      state.namespaces = data;
    },
    updateNamespaces(state, ns) {
      Vue.set(state.namespaces, ns.name, ns);
    },
    resetNodePools(state, data) {
      state.nodepools = data;
    },
    updateNodePools(state, nodepool) {
      Vue.set(state.nodepools, nodepool.name, nodepool);
    },
    resetApps(state, data) {
      state.apps = data;
    },
    updateApps(state, app) {
      Vue.set(state.apps, app.clustername+app.namespace+app.name, app);
    },
    updateError(state, err) {
      state.error.value = true;
      if (err.stream) {
        state.error.stream = true;
      } else {
        state.error.stream = false;
      }
      state.error.code = err.err.code;
      if (err.err.message) {
        state.error.message = err.err.message;
      } else if (err.err.details) {
        state.error.message = err.err.details;
      }
      // state.isLoading.history = false;
    },
    clearError(state) {
      state.error.value = false;
      state.error.stream = false;
      state.error.code = null;
      state.error.message = '';
    }
  },
  getters: {
    allClusters: (state) => {
      return state.clusters;
    },
    allNamespaces: (state) => {
      return state.namespaces;
    },
    allNodePools: (state) => {
      return state.nodepools;
    },
    allApps: (state) => {
      return state.apps;
    },
    error: (state) => {
      return state.error;
    }
  },
  actions: {
    listClusters({commit}) {
      return new Promise(function(resolve, reject) {
        auth.getAccessToken().then(accessToken => {
          var metadata = {'Authorization': 'Bearer ' + accessToken};
          var request = new Cluster();
          var stream = avClient.listClusters(request, metadata);
          stream.on('data', function(response) {
            var ns = response.toObject();
            commit('updateClusters', ns);
          });
          stream.on('end', function() {
            resolve();
          });
          stream.on('error', (err) => {
            commit('updateError', {err: err, func: 'listClusters'});
            reject();
          });
        });
      });
    },
    resetNamespaces({commit}) {
      commit('resetNamespaces', {});
    },
    listNamespaces({commit}, args) {
      return new Promise(function(resolve, reject) {
        auth.getAccessToken().then(accessToken => {
          var metadata = {'Authorization': 'Bearer ' + accessToken};
          var request = new Namespace();
          if (args) {
            request.setClustername(args.clustername);
          }
          var stream = avClient.listNamespaces(request, metadata);
          var nss = {};
          stream.on('data', function(response) {
            var ns = response.toObject();
            nss[ns.name] = ns;
          });
          stream.on('end', function() {
            commit('resetNamespaces', nss);
            resolve(nss);
          });
          stream.on('error', (err) => {
            commit('updateError', {err: err, func: 'listNamespaces'});
            reject();
          });
        });
      });
    },
    refreshTags({commit}) {
      return new Promise(function(resolve, reject) {
        auth.getAccessToken().then(accessToken => {
          var metadata = {'Authorization': 'Bearer ' + accessToken};
          var empty = new Empty();
          var reply = avClient.refreshTags(empty, metadata);
          reply.on('data', function() {
            store.dispatch('listNamespaces');
            resolve();
          });
          reply.on('error', (err) => {
            commit('updateError', {err: err, func: 'refreshTags'});
            reject(err);
          });
        });
      });
    },
    resetNodePools({commit}) {
      commit('resetNodePools', {});
    },
    listNodePools({commit}, args) {
      var parent = this;
      return new Promise(function(resolve, reject) {
        if (parent.nodePoolStream) {
          parent.nodePoolStream.cancel();
        }
        auth.getAccessToken().then(accessToken => {
          var metadata = {'Authorization': 'Bearer ' + accessToken};
          var request = new NodePool();
          if (args) {
            request.setClustername(args.clustername);
          }
          parent.nodePoolStream = avClient.listNodePools(request, metadata);
          var nps = [];
          parent.nodePoolStream.on('data', function(response) {
            var np = response.toObject();
            nps[np.name] = np
            commit('updateNodePools', np);
          });
          parent.nodePoolStream.on('end', function() {
            commit('resetNodePools', nps);
            resolve(nps);
          });
          parent.nodePoolStream.on('error', (err) => {
            commit('updateError', {err: err, func: 'listNodePools'});
            reject();
          });
        });
      });
    },
    resetApps({commit}) {
      commit('resetApps', {});
    },
    watchApps({commit}, args) {
      if (!args) args = {};
      if (!args.retry) args.retry = 0;
      if (!this.appsStreams) {
        this.appsStreams = [];
      }
      var parent = this;
      auth.getAccessToken().then(accessToken => {
        if (parent.appsStreams[args.clustername+args.namespace]) {
          parent.appsStreams[args.clustername+args.namespace].cancel()
        }
        var metadata = {'Authorization': 'Bearer ' + accessToken};
        var request = new Namespace();
        if (args) {
          request.setClustername(args.clustername);
          request.setName(args.namespace);
        }
        parent.appsStreams[args.clustername+args.namespace] = avClient.watchApps(request, metadata);
        parent.appsStreams[args.clustername+args.namespace].on('data', function(response) {
          args.retry = 0;
          var app = response.toObject()
          commit('updateApps', app);
        });
        parent.appsStreams[args.clustername+args.namespace].on('error', (err) => {
          if (args.retry < 5) {
            args.retry += 1;
            store.dispatch('watchApps', args);
          } else {
            commit('updateError', {err: err, func: 'watchApps'});
          }
        });
      });
    },
    cancelStreams({commit}) {
      if (this.appsStreams) {
        this.appsStreams.forEach((s) => {
          s.cancel().catch((err) => { 
            commit('updateError', {err: err, func: 'cancelStreams'});
          })
        })
      }
    },
    clearError({commit}) {
      commit('clearError');
    }
  }
});

export default store;